import uppercase from '@/filters/uppercase';
import date from '@/filters/date';
import arsCurrency from '@/filters/ars-currency';
import usdCurrency from '@/filters/usd-currency';
import calculateDensity from '@/filters/calculateDensity';
import decimals from '@/filters/decimals';
import capitalizeFirstLetter from '@/util/capitalizeFirstLetter';
import percentage from '@/filters/percentage';

const GlobalFilters = {
  install(Vue) {
    Vue.filter('uppercase', uppercase);
    Vue.filter('date', date);
    Vue.filter('toCurrencyARS', arsCurrency);
    Vue.filter('toCurrencyUSD', usdCurrency);
    Vue.filter('seedsPerHectare', calculateDensity);
    Vue.filter('plantsDensity', calculateDensity);
    Vue.filter('decimals', decimals);
    Vue.filter('capitalize', capitalizeFirstLetter);
    Vue.filter('percentage', percentage);
  },
};

export default GlobalFilters;
